import { Component } from '@angular/core';
import { PhysicalCreditCard } from './card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class CreditCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: PhysicalCreditCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }
}
